import React from "react";
import Bolt from "@/components/Bolt";
import LogisticsAnimation from "@/components/LogisticsAnimation";

export default function PageHero({ eyebrow, title, subtitle, animation = "all" }) {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-36 sm:pt-40 pb-16 sm:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0 zp-grid-bg opacity-40 pointer-events-none" />
      <div className="absolute inset-0 zp-radial pointer-events-none" />
      {animation && <LogisticsAnimation variant={animation} />}
      <Bolt
        size={320}
        color="#5CE1E6"
        className="absolute right-4 top-24 pointer-events-none hidden md:block"
        style={{ opacity: 0.10, transform: "rotate(12deg)" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {eyebrow && <div className="zp-label">{eyebrow}</div>}
        <h1 className="font-display font-bold text-4xl sm:text-6xl tracking-tighter leading-[1.05] mt-3 max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[color:var(--zp-text-2)] mt-6 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
